import hasStartedAndNotEndedPlanUtil from '../../../../modules/plan/model/utils/has-started-and-not-ended'
import getByIdPlanSelector from '../get-by-id'
import { createSelector } from 'reselect'

function hasStartedAndNotEndedByIdPlanSelector (id) {
  return createSelector(getByIdPlanSelector(id), (instance) => {
    return hasStartedAndNotEndedPlanUtil(instance)
  })
}

export default hasStartedAndNotEndedByIdPlanSelector
